<template>
  <div id="ac-icon">
    <svg id="ac-svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2.8346999 2.8346" style="enable-background:new 0 0 2.8346999 2.8346;" xml:space="preserve">
      <g>
        <rect class="st7" width="2.8346999" height="2.8346" />
        <g>
          <polygon class="st2" points="0.3422,2.444 0.3422,2.4909999 2.4909999,2.4895 2.4909999,2.1617 		" />
          <path class="st2" d="M1.1264,2.0722001c0.2512,0,0.4707184-0.1408001,0.5804-0.348L1.6114999,1.5963 C1.5358,1.7920001,1.3487999,1.9313999,1.1264,1.9313999c-0.2859,0-0.5199-0.2333-0.5199-0.5206 c0-0.1206,0.0419-0.2325,0.1126184-0.3213L0.6873,0.9184C0.5509,1.0382,0.465,1.2158,0.465,1.4108 C0.465,1.7776,0.7617,2.0722001,1.1264,2.0722001z" />
          <path class="st2" d="M0.6953,0.5545v0.0014c0.0008184,0.0058,0.0008184,0.0115,0.0022,0.018l0.0079,0.0426L0.826,1.2476 c0.0058,0.0369,0.039,0.0599,0.0751184,0.0563L1.4397,1.2404l0.3306999,0.4419C1.7806,1.6981,1.7993,1.7097,1.818,1.7104 c0.0023,0,0.0051185,0,0.008,0c0.0166,0,0.0325-0.0043,0.0454999-0.0158L2.0325,1.5552C2.0362,1.5508,2.0376,1.5508,2.0397,1.548 L1.9495,1.4425C1.9466,1.444,1.9423,1.4469,1.9409,1.4469L1.8368,1.5378l-0.3083-0.413 c-0.0151-0.0194-0.0397-0.0317-0.0656-0.0295L0.9523,1.1566L0.9372,1.0865999L1.3068,1.0238 C1.3451184,1.018,1.3717999,0.9819,1.3652999,0.9429S1.3212999,0.878,1.2845,0.8845L0.9126,0.9472L0.8671184,0.7248 C0.8737,0.7263,0.8794,0.7263,0.8859,0.7263c0.1061,0,0.1899-0.0866,0.1899-0.1935c0-0.1054-0.0838-0.1899-0.1899-0.1899 S0.6953,0.4274,0.6953,0.5328C0.6953,0.54,0.6953,0.5487,0.6953,0.5545L0.6953,0.5545z" />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
svg {
  width: 100%;
}

.st2 {
  fill: #ffffff;
}
.st7 {
  fill: #005bac;
}
</style>
